import {history} from "./history";

export class Utilities {

  static wait = (ms: number = 1000) => new Promise((resolve) => setTimeout(resolve, ms));

  static getQueryParam(query: string): string | null {
    const searchParams: URLSearchParams = new URLSearchParams(history.location.search);
    return searchParams.get(query);
  }

  static goToUrl(url: string) {
    window.location.href = url;
  }
}
